// Lib
import type { TIPostTypesType } from '@/lib/posts/postTypes';
import { getPostType } from '@/lib/posts/postTypes';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import Post from '@/components/base/Post';
import { AlbumPostIcon } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/AlbumPostIcon';

type TiktokAlbumPostProps = {
    data: {
        type: TIPostTypesType;
    };
    shouldDisplayIcon: boolean;
};
const TiktokAlbumPost = ({ data, shouldDisplayIcon }: TiktokAlbumPostProps) => {
    const type = getPostType({ network: TIKTOK_BUSINESS, type: data?.type });

    return (
        <Post data={data} className="w-full">
            <Post.Content className="relative w-full">
                <AlbumPostIcon show={type && shouldDisplayIcon} type={type} />
                <div className="story relative">
                    <Post.Image />
                </div>
            </Post.Content>
        </Post>
    );
};

export default TiktokAlbumPost;
